import {Injectable} from '@angular/core';
import {SessionService} from '../session';
import {BackendModule} from '../../modules/backend.module';
import {FirebaseService} from '../firebase';
import firebase from 'firebase/app';
import 'firebase/messaging';

@Injectable()
export class PWAPushService {

  messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;

  constructor(
    public fbService: FirebaseService,
    public backendModule: BackendModule,
    public sessionService: SessionService
  ) {
  }

  askFirebasePermission() {
    return new Promise((resolve, reject) => {
      if (!this.messaging) reject('Browser not suported')
      navigator.serviceWorker
        .register('service-worker.js')
        .then(registration => {
          this.messaging.useServiceWorker(registration);
          this.messaging
            .requestPermission()
            .then(() => {
              console.log('Notification permission granted.');
              resolve(true);
            })
            .catch(function (err) {
              this.sessionService && this.sessionService.reportError(
                'pwaPushService',
                'askFirebasePermission() requestPermission()',
                err
              );
              reject(err);
            });
        })
        .catch(err => {
          this.sessionService && this.sessionService.reportError(
            'pwaPushService',
            'askFirebasePermission() serviceWorker.register()',
            err
          );
        });
    });
  }

  getFirebaseToken() {
    if (!this.messaging) return
    this.messaging
      .getToken()
      .then(currentToken => {
        if (currentToken) {
          console.log('current Token', currentToken);
          this.saveToken(currentToken);
        } else {
          console.log(
            'No Instance ID token available. Request permission to generate one.'
          );
        }
      })
      .catch(err => {
        this.sessionService && this.sessionService.reportError(
          'pwaPushService',
          'getFirebaseToken()',
          err
        );
      });
    this.monitorTokenRefresh();
  }

  monitorTokenRefresh() {
    if (!this.messaging) return;

    this.messaging.onTokenRefresh(() => {
      this.messaging.getToken().then((refreshedToken) => {
        console.log('Token refreshed.');
        this.saveToken(refreshedToken);
      }).catch(function (err) {
        this.sessionService.reportError(
          'pwaPushService',
          'monitorTokenRefresh()',
          err
        );
      });
    });
  }

  onReceiveFirebaseMessage() {
    if (!this.messaging) return;
    this.messaging.onMessage(function (payload) {
      console.log('Message received. ', payload);
      // ...
    });
  }

  saveToken(token) {
    this.backendModule
      .putAPI(`users/${this.sessionService.user.id}`, {
        user: {pwa_firebase_token: token}
      })
      .subscribe(
        success => {
          console.log('pushNotificationService: saved FCMToken' + success);
        },
        err => {
          this.sessionService.reportError(
            'pwaPushService',
            'saveToken()',
            err
          );
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/services/notifications/pwa-push.ts